import React, { useMemo } from "react";
import "./InsightBanner.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useInsightsSection } from "../../../../context/InsightsPageContext";
import { resolveMediaUrl } from "../../../../utils/resolveMediaUrl";

const InsightBanner = () => {
  const { section, loading } = useInsightsSection("insight-banner");

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url;
    return url ? resolveMediaUrl(url) : "";
  }, [section]);

  if (loading || !section?.fields) return null;

  const fields = section.fields;

  return (
    <section className="insight-banner">
      {bgSrc ? <img src={bgSrc} alt="" className="insight-banner__bg" /> : null}

      <div className="insight-banner__overlay" />

      <div className="insight-banner__content">
        {fields.label ? (
          <CmsText
            content={fields.label}
            as="span"
            className="insight-banner__label"
          />
        ) : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h1" />
        ) : null}

        {fields.description ? (
          <RichTextContent content={fields.description} />
        ) : null}
      </div>
    </section>
  );
};

export default InsightBanner;
